/**
 * @module router/modules/public
 * @description 공개 라우트 모듈 — 인증 없이 접근 가능한 페이지를 정의합니다.
 * 배송 조회, 고객용 AS 페이지, 로그인, 접수증/내역서 출력 페이지가 포함됩니다.
 */
const routes = [
  {
    path: '/delivery/search',
    name: '배송 조회',
    component: () => import(/* webpackChunkName: "deliverySearch" */ '../../views/delivery/DeliverySearch.vue'),
    meta: { platform: 'web', menuYn: false, authorization: false }
  },
  {
    path: '/as/main',
    name: '고객용 as main',
    component: () => import(/* webpackChunkName: "asMain" */ '../../views/as/AsMain.vue'),
    meta: { platform: 'web', menuYn: false, authorization: false }
  },
  {
    path: '/as/search',
    name: '고객용 as 조회',
    component: () => import(/* webpackChunkName: "asSearch" */ '../../views/as/AsSearch.vue'),
    meta: { platform: 'web', menuYn: false, authorization: false }
  },
  {
    path: '/mobile/as/search',
    name: '고객용 as 조회 mobile 화면',
    component: () => import(/* webpackChunkName: "mobileAsSearch" */ '../../views/mobile/customer/MobileAsSearch.vue'),
    meta: { platform: 'mobile', menuYn: false, authorization: false }
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "login" */ '../../views/login/LoginView.vue'),
    meta: { platform: 'web', menuYn: false, authorization: false }
  },
  {
    path: '/redirect',
    redirect: 'login',
    meta: { platform: 'web', menuYn: false, authorization: false }
  },
  {
    path: '/repair-receipt/:repairRequestId',
    name: '접수증 출력 페이지',
    component: () => import('../../views/repairManagement/RequestStatement.vue'),
    meta: { platform: 'web', menuYn: false, authorization: false }
  },
  {
    path: '/repair-report/:repairRequestId',
    name: '내역서 출력 페이지',
    component: () => import('../../views/repairManagement/RepairStatement.vue'),
    meta: { platform: 'web', menuYn: false, authorization: false }
  },
  {
    path: '/mobile/repair-report/:repairRequestId',
    name: '내역서 출력 페이지 모바일',
    component: () => import('../../views/repairManagement/RepairStatement.vue'),
    meta: { platform: 'mobile', menuYn: false, authorization: false }
  }
]

export default routes
